import React, { useState } from 'react';
import { XIcon, ShieldCheckIcon, FileTextIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  if (!type) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-15">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-16">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-light" data-id="element-17">
          <div className="flex items-center gap-2" data-id="element-18">
            {type === 'privacy' ? <ShieldCheckIcon className="w-5 h-5 text-navy" data-id="element-19" /> : <FileTextIcon className="w-5 h-5 text-navy" data-id="element-20" />}
            <h2 className="text-xl font-bold text-navy font-heading" data-id="element-21">
              {type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
            </h2>
          </div>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 transition-colors" aria-label="Cerrar" data-id="element-22">
            <XIcon className="w-5 h-5 text-text-muted" data-id="element-23" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[70vh] text-text-dark text-base leading-relaxed space-y-4" data-id="element-24">
          {type === 'privacy' ? <PrivacyContent data-id="element-25" /> : <TermsContent data-id="element-26" />}
        </div>
      </div>
    </div>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-text-muted" data-id="element-27">
        Última actualización: Marzo 2026
      </p>

      <h3 className="text-lg font-bold text-navy mt-4" data-id="element-28">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-29">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital. Esto incluye tu nombre, dirección de
        correo electrónico y datos de pago procesados de forma segura a través
        de nuestro proveedor de pagos.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-30">2. Uso de la Información</h3>
      <p data-id="element-31">Tu información personal se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-32">
        <li data-id="element-33">Procesar y entregar tu compra digital.</li>
        <li data-id="element-34">
          Enviarte actualizaciones relacionadas con el producto adquirido.
        </li>
        <li data-id="element-35">Responder a tus consultas de soporte.</li>
      </ul>

      <h3 className="text-lg font-bold text-navy" data-id="element-36">3. Protección de Datos</h3>
      <p data-id="element-37">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. No almacenamos datos de tarjetas de
        crédito en nuestros servidores. Todos los pagos son procesados a través
        de plataformas seguras con encriptación SSL.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-38">4. Compartir Información</h3>
      <p data-id="element-39">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción es nuestro procesador de pagos, que
        necesita datos mínimos para completar la transacción.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-40">5. Cookies</h3>
      <p data-id="element-41">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación. Puedes configurar tu navegador para rechazar cookies, aunque
        esto podría afectar algunas funcionalidades del sitio.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-42">6. Tus Derechos</h3>
      <p data-id="element-43">
        Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
        personales en cualquier momento. Para ejercer estos derechos, puedes
        comunicarte con nosotros a través de los canales disponibles en nuestro
        sitio.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-text-muted" data-id="element-44">
        Última actualización: Marzo 2026
      </p>

      <h3 className="text-lg font-bold text-navy mt-4" data-id="element-45">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-46">
        Al adquirir el producto digital "Crédito USA: Método 700+", aceptas
        estos términos y condiciones en su totalidad. Si no estás de acuerdo con
        alguno de estos términos, te pedimos que no realices la compra.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-47">
        2. Naturaleza del Producto
      </h3>
      <p data-id="element-48">
        Este es un producto digital educativo en formato PDF. El contenido tiene
        fines informativos y educativos únicamente. No constituye asesoría
        legal, financiera o profesional de ningún tipo.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-49">3. Resultados</h3>
      <p data-id="element-50">
        Los resultados descritos en el material de venta son ejemplos
        ilustrativos. Los resultados individuales pueden variar
        significativamente dependiendo de la situación personal, el historial
        financiero y la consistencia en la aplicación del método. No
        garantizamos resultados específicos.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-51">4. Entrega del Producto</h3>
      <p data-id="element-52">
        Una vez completado el pago, recibirás acceso inmediato al producto
        digital. El enlace de descarga se enviará al correo electrónico
        proporcionado durante la compra.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-53">5. Propiedad Intelectual</h3>
      <p data-id="element-54">
        Todo el contenido del producto está protegido por derechos de autor.
        Queda prohibida la reproducción, distribución o reventa del material sin
        autorización expresa por escrito.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-55">6. Política de Reembolso</h3>
      <p data-id="element-56">
        Ofrecemos una garantía de satisfacción. Si no estás satisfecha con el
        producto, puedes solicitar un reembolso dentro de los primeros 7 días
        posteriores a la compra, siempre y cuando no hayas descargado la
        totalidad del material.
      </p>

      <h3 className="text-lg font-bold text-navy" data-id="element-57">
        7. Limitación de Responsabilidad
      </h3>
      <p data-id="element-58">
        No nos hacemos responsables por decisiones financieras tomadas basándose
        en el contenido de esta guía. Recomendamos consultar con un profesional
        financiero certificado antes de tomar decisiones importantes sobre tu
        crédito.
      </p>
    </>;
}
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-gray-400 py-10 px-4" data-id="element-59">
        <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-60">
          <div className="flex justify-center gap-6 text-sm" data-id="element-61">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gold transition-colors underline underline-offset-2" data-id="element-62">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-63">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-gold transition-colors underline underline-offset-2" data-id="element-64">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-sm" data-id="element-65">
            © {new Date().getFullYear()} Crédito USA: Método 700+. Todos los
            derechos reservados.
          </p>

          <p className="text-xs opacity-70 max-w-2xl mx-auto" data-id="element-66">
            Descargo de responsabilidad: Los resultados pueden variar. Esta guía
            tiene fines educativos y no constituye asesoría legal o financiera
            profesional.
          </p>
        </div>
      </footer>

      <Modal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-67" />
    </>;
}